import { legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { useEditorSurface } from '../../EditorSurfaceContext'

// Page fieldset — page colour / margin / padding text inputs.
const pageOptions = [
  { name: 'is_page_options_color', def: '#ffffff', isColor: true, label: 'Background:' },
  { name: 'is_page_options_margin', def: '0', label: 'Margin:' },
  { name: 'is_page_options_padding', def: '15', label: 'Padding:' },
]

export function PagePanel() {
  const { skin } = useEditorSurface()
  const classes = skin.settings
  return (
    <fieldset {...legacyContractDataAttrs('editor.settings.pageOptions')} className={classes.panel}>
      <legend className={classes.legend}>Page</legend>
      {pageOptions.map(opt => (
        <label key={opt.name} className={classes.field}>
          {opt.label}
          <input
            {...(opt.isColor ? legacyContractDataAttrs('editor.settings.pageColor') : {})}
            type="text"
            name={opt.name}
            defaultValue={opt.def}
            className={classes.textInput}
          />
        </label>
      ))}
    </fieldset>
  )
}
